import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { auth, storage } from "./firebase";
import { nanoid } from "nanoid";
import { useAuth } from './context';
import { getFirestoreDoc, setFirebaseDoc, setFirestoreDoc, storeMetadata } from "./firestore";
import { arrayRemove, arrayUnion } from "firebase/firestore";

export const uploadFile = async (file, docType, signature=false) => {
	const uid = auth.currentUser.uid;
	const fileExtension = file.name.split('.').pop();
	const fileNanoId = nanoid();
	let storageRef = null;
	console.log('FILE NAME', file.name)
	console.log('FILE EXTENSION', fileExtension)
	console.log('DOC TYPE', docType)
	
	if (signature) {
		storageRef = ref(storage, `signatures/${uid}/${fileNanoId}`)
	}
	else {
		storageRef = ref(storage, `documents/${uid}/${fileNanoId}`);
	}
    await uploadBytes(storageRef, file);

	const docMetadata = {
		docType: docType,
		uuid: fileNanoId,
		extension: fileExtension,
		uploadTime: Date.now() / 1000,
	}

	if (signature) {
		setFirestoreDoc(`/signatures/${uid}/`, { docs: arrayUnion(docMetadata) });
	}
	else {
		setFirestoreDoc(`/documents/${uid}/`, { docs: arrayUnion(docMetadata) })
	}

	return fileNanoId;
};

export const getFile = async (fileID, signature=false, returnFileURL=false) => {
	const uid = auth.currentUser.uid;
	let storageRef = null;
	if (signature) {
		storageRef = ref(storage, `signatures/${uid}/${fileID}`)
	}
	else {
		storageRef = ref(storage, `documents/${uid}/${fileID}`);
	}
	
	try {
		const fileURL = await getDownloadURL(storageRef);
		if (returnFileURL) {
			return fileURL;
		}
		const response = await fetch(fileURL);
		const blob = await response.blob();
		return blob;
	}
	catch(error) {
		console.log('getFile error');
		return null;
	}
}

export const deleteFile = async (docID, signature=false) => {
	console.log('docID', docID);
	const uid = auth.currentUser.uid;
	const fileRef = ref(storage, `gs://lot-number-9a1dc.appspot.com/documents/${uid}/${docID}`);
	try {
		await deleteObject(fileRef);
		console.log(`File ${docID} deleted successfully.`);
	} catch (error) {
		console.error("Error deleting file:", error);
		throw new Error("Error deleting file");
	}

	
	//This is basically just setGlobalDocs (in firestore.js), which itself is incrluded for completeness but is perhaps superfluous.
	try {
		const docsPath = `/documents/${uid}`;
		const docsPromise = await getFirestoreDoc(docsPath);
		const docsArray = docsPromise.docs;
		const updatedDocsArray = docsArray.filter( doc => doc.uuid !== docID );
		setFirestoreDoc(docsPath, {docs: updatedDocsArray});
	}
	catch {
		console.log("Cannot delete document from Firestore backend.");
	}

// 	setFirestoreDoc(`/documents/${uid}/`, { docs: arrayRemove() })	
};


//Converts a Base64 data URL to a File object
//We need for uploading signature canvas
export function dataURLtoFile(dataURL, filename) {
	const arr = dataURL.split(",");
	const mime = arr[0].match(/:(.*?);/)[1];
	const bstr = atob(arr[1]);
	let n = bstr.length;
	const u8arr = new Uint8Array(n);
	while (n--) {
		u8arr[n] = bstr.charCodeAt(n);
	}
	return new File([u8arr], filename, { type: mime });
}
